import React from 'react';
import { FadeIn } from './FadeIn';
import { BuildingIcon, LandmarkIcon, Building2Icon, WalletIcon, PiggyBankIcon } from 'lucide-react';
export function TrustedBy() {
  const partners = [{
    name: 'FI First Design',
    icon: LandmarkIcon
  }, {
    name: 'Credit Unions',
    icon: BuildingIcon
  }, {
    name: 'Regional Banks',
    icon: Building2Icon
  }, {
    name: 'FinTechs',
    icon: WalletIcon
  }, {
    name: 'Commercial Banks',
    icon: PiggyBankIcon
  }];
  return <section className="py-12 border-b border-white/5 bg-navy" data-id="element-628">
      <div className="max-w-7xl mx-auto px-6" data-id="element-629">
        <FadeIn data-id="element-630">
          <p className="text-center text-sm font-medium text-gray-500 uppercase tracking-widest mb-8" data-id="element-631">
            Trusted by forward-thinking financial institutions
          </p>
          <div className="flex flex-wrap justify-center items-center gap-12 md:gap-20 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-632">
            {partners.map((partner, index) => {
            const Icon = partner.icon;
            return <div key={index} className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors duration-300" data-id="element-633">
                  <Icon className="w-8 h-8" strokeWidth={1.5} data-id="element-634" />
                  <span className="text-lg font-semibold tracking-tight" data-id="element-635">
                    {partner.name}
                  </span>
                </div>;
          })}
          </div>
        </FadeIn>
      </div>
    </section>;
}